'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var ExpandMoreIcon = _interopDefault(require('@material-ui/icons/ExpandMore'));
var styledComponents = require('./styled-components.js');

var TextWithExpansion = function (props) {
    var children = props.children, text = props.text, id = props.id, expanded = props.expanded, _a = props.onChange, onChange = _a === void 0 ? function () { } : _a;
    var onExpansionChange = function (e, isExpanded) {
        onChange(isExpanded);
    };
    return (React__default.createElement(styledComponents.ExpansionContainer, null,
        React__default.createElement(core.ExpansionPanel, { onChange: onExpansionChange, expanded: expanded },
            React__default.createElement(core.ExpansionPanelSummary, { expandIcon: React__default.createElement(ExpandMoreIcon, null), "aria-controls": id, id: id },
                React__default.createElement(styledComponents.DetailsText, null, text)),
            React__default.createElement(core.ExpansionPanelDetails, null, children))));
};

module.exports = TextWithExpansion;
